import { atom, createStore } from 'jotai';
import { IMasteryTopic } from '@models/interfaces/student.interface';

const progressStore = createStore();

// pure atom
export const selectedBreakdownIdAtom = atom<null | number>(null);
export const masteryTopicsAtom = atom<IMasteryTopic[]>([]);

// derived atom
export const selectedBreakdownTopicAtom = atom(get => {
  const selectedBreakdownId = get(selectedBreakdownIdAtom);
  if (selectedBreakdownId) {
    return get(masteryTopicsAtom).find(
      masteryTopic => Number(masteryTopic.topic_id) == selectedBreakdownId,
    );
  }
  return null;
});

export function setDefaultProgressStore() {
  progressStore.set(selectedBreakdownIdAtom, null);
  progressStore.set(masteryTopicsAtom, []);
}

setDefaultProgressStore();
export default progressStore;
